/**
 * TaxReports API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  exportSloveniaVodXml,
  exportSloveniaYearlyNormiraniReport,
  generateKirExport,
  getSloveniaTaxProfile,
  reviewSloveniaYearlyNormiraniReport,
  updateSloveniaTaxProfile,
} from "../generated/tax-reports/tax-reports";

import { wrapMethod } from "./utils";

export const taxReports = {
  /** @see generateKirExport */
  generateKirExport: wrapMethod(generateKirExport),

  /** @see getSloveniaTaxProfile */
  getSloveniaTaxProfile: wrapMethod(getSloveniaTaxProfile),

  /** @see updateSloveniaTaxProfile */
  updateSloveniaTaxProfile: wrapMethod(updateSloveniaTaxProfile),

  /** @see reviewSloveniaYearlyNormiraniReport */
  reviewSloveniaYearlyNormiraniReport: wrapMethod(reviewSloveniaYearlyNormiraniReport),

  /** @see exportSloveniaYearlyNormiraniReport */
  exportSloveniaYearlyNormiraniReport: wrapMethod(exportSloveniaYearlyNormiraniReport),

  /** @see exportSloveniaVodXml */
  exportSloveniaVodXml: wrapMethod(exportSloveniaVodXml),
} as const;

export type TaxReportsApi = typeof taxReports;
